













import Vue from 'vue';
import eventBus from '@/plugins/eventBus';
import {
  Message,
  MessageTypesStyle,
  MessageTypesStylesDefs,
} from '@/lib/models/message';

export default Vue.extend({
  data() {
    return {
      isShown: false,
      message: undefined as Message | undefined,
    };
  },
  computed: {
    messageStyle(): MessageTypesStyle {
      return MessageTypesStylesDefs[this.message?.type ?? 'info'];
    },
  },
  methods: {
    closeMessage(): void {
      this.isShown = false;
      this.message = undefined;
    },
  },
  mounted(): void {
    eventBus.on('message', (message: Message): void => {
      this.message = message;
      this.isShown = true;
    });
  },
});
